import styled from 'styled-components'

/** NOTE:
 * If the button is inside a form, the default type will be treated as submit,
 * so we set the type `button` to avoid triggering form submission.
 * */
const NoStyleNativeButton = styled.button.attrs({ type: 'button' })`
  background: none;
  border: none;
  padding: 0;
  outline: none;
`

export default NoStyleNativeButton
